import React from 'react';
import {useDispatch} from 'react-redux';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import {IElementShape} from '../../../../incase-domain/elements/base/shapeElementBase';
import {SHAPE_COLOR_DEFAULT} from '../../../../constants';

interface StarElementProps {
    element: IElementShape;
    thickness?: number;
}

StarElement.defaultProps = {
    thickness: 0.0625,
};

function StarElement(props: StarElementProps): JSX.Element {
    const {element, thickness} = props;
    const {color, fill, slideChange} = element;

    const dispatch = useDispatch();

    if (fill) {
        return (
            <div className="c-star c-star--filled" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
                <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 32 32"
                    xmlSpace="preserve"
                >
                    <polygon
                        points="22.137,19.625 32,12 20,12 16,0 12,12 0,12 9.875,19.594 6,32 16.016,24.32 26.008,32"
                        fill={color || SHAPE_COLOR_DEFAULT}
                    />
                </svg>
            </div>
        );
    }

    return (
        <div className="c-star" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
            <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 490 490"
                xmlSpace="preserve"
            >
                <path
                    d="M245,2.219L186.921,188.05H0l151.225,114.23L93.252,487.781L245,373.133l151.733,114.648l-57.959-185.502L490,188.05
	          H303.079L245,2.219z M320.964,296.572l46.932,150.239L245,353.948l-122.911,92.863l46.947-150.239L45.632,
	          203.35h152.525L245,53.499 l46.842,149.851h152.525L320.964,296.572z"
                    fill={color || SHAPE_COLOR_DEFAULT}
                    stroke={color || SHAPE_COLOR_DEFAULT}
                    strokeWidth={`${thickness}em`}
                />
            </svg>
        </div>
    );
}

export default StarElement;
